import kpnFoto from '../assets/KPN-logo-vierkant.jpeg';

const FotoCard = (props) => {
  return (
        <div className='questionBox'>
          <div className='foto-box '>
            <div className='foto'>
              <img src={props.item.image} alt='#' />
            </div>
            <div className='foto-text table-container'>
              <table>
                <thead>
                  <tr>
                    <th colSpan={2}>{props.item.type}</th>
                  </tr>
                </thead>
                <tbody>
                  {/* loop over sub array of objects en maak table row gevuld met tabele data */}
                  {props.item.kabel.map((key) => {
                    return (
                      <tr key={key.key}>
                        <td>{key.naam}</td>
                        <td>{key.kleur}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
      </div>
  );
};

export default FotoCard;
